var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Ustawienia systemowe globalne")]),
      _c("v-select", {
        attrs: {
          items: _vm.passwordOptions,
          label: "Możliwość zapisywania hasła w przeglądarce"
        },
        model: {
          value: _vm.canSavePassword,
          callback: function($$v) {
            _vm.canSavePassword = $$v
          },
          expression: "canSavePassword"
        }
      }),
      _c("v-select", {
        attrs: { items: _vm.enableDisable, label: "Customizacja pod agencję" },
        model: {
          value: _vm.is_wnt,
          callback: function($$v) {
            _vm.is_wnt = $$v
          },
          expression: "is_wnt"
        }
      }),
      _c("h2", [_vm._v("Ustawienia w kontekście administracyjnym")]),
      _c("v-select", {
        attrs: {
          label: _vm.$t("settings.systemSettings.accessFromNonBlockedIp"),
          items: _vm.allowDeny
        },
        model: {
          value: _vm.access_from_non_blocked_ip,
          callback: function($$v) {
            _vm.access_from_non_blocked_ip = $$v
          },
          expression: "access_from_non_blocked_ip"
        }
      }),
      _c("v-combobox", {
        ref: "whitelist",
        attrs: { label: "Whitelist", multiple: "", chips: "" },
        model: {
          value: _vm.ip_whitelist,
          callback: function($$v) {
            _vm.ip_whitelist = $$v
          },
          expression: "ip_whitelist"
        }
      }),
      _c("v-combobox", {
        ref: "blacklist",
        attrs: { label: "BlackList", multiple: "", chips: "" },
        model: {
          value: _vm.ip_blacklist,
          callback: function($$v) {
            _vm.ip_blacklist = $$v
          },
          expression: "ip_blacklist"
        }
      }),
      _c("input", { ref: "focusout", attrs: { type: "hidden" } }),
      _c("v-btn", { ref: "saveButton", on: { click: _vm.saveSettings } }, [
        _vm._v("Zapisz")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }